module.exports = __webpack_public_path__ + "87f35745574d021b0aad362b26e743f9.svg";